var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6495C6.477 22.6495 2 18.1725 2 12.6495C2 7.12654 6.477 2.64954 12 2.64954C17.523 2.64954 22 7.12654 22 12.6495C22 18.1725 17.523 22.6495 12 22.6495ZM12 20.6495C14.1217 20.6495 16.1566 19.8067 17.6569 18.3064C19.1571 16.8061 20 14.7713 20 12.6495C20 10.5278 19.1571 8.49297 17.6569 6.99268C16.1566 5.49239 14.1217 4.64954 12 4.64954C9.87827 4.64954 7.84344 5.49239 6.34315 6.99268C4.84285 8.49297 4 10.5278 4 12.6495C4 14.7713 4.84285 16.8061 6.34315 18.3064C7.84344 19.8067 9.87827 20.6495 12 20.6495ZM11.003 16.6495L6.76 12.4065L8.174 10.9925L11.003 13.8215L16.659 8.16454L18.074 9.57854L11.003 16.6495Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.6e8f6d4f337664b15dedd2a25c07a034.svg";
export { ForwardRef as ReactComponent };